import { ConsoleLogger } from './console-logger';

export type LogLevelType = 'debug' | 'error' | 'info' | 'trace' | 'warn';

export enum LogLevel {
    trace = 0,
    debug = 1,
    info = 2,
    warn = 3,
    error = 4
}

export interface ILoggerOutput {
    log: (level: LogLevel, args: any[]) => void;
    exception: (error: unknown, customProperties?: Record<string, any>) => void;
}

class Logger {
    private loggers: ILoggerOutput[] = [];

    private log(level: LogLevel, args: any[]) {
        this.loggers.forEach((x) => x.log(level, args));
    }

    trace(...args: any[]) {
        this.log(LogLevel.trace, args);
    }
    debug(...args: any[]) {
        this.log(LogLevel.debug, args);
    }
    info(...args: any[]) {
        this.log(LogLevel.info, args);
    }
    warn(...args: any[]) {
        this.log(LogLevel.warn, args);
    }
    error(...args: any[]) {
        this.log(LogLevel.error, args);
    }

    trackException(error: unknown, customProperties?: Record<string, any>) {
        this.loggers.forEach((x) => x.exception(error, customProperties));
    }

    addConsole(config: Partial<{ minLevel: (typeof LogLevel)[keyof typeof LogLevel] }>): Logger {
        this.add(new ConsoleLogger('', config.minLevel ?? LogLevel.debug));
        return this;
    }

    add(logger: ILoggerOutput): Logger {
        this.loggers.push(logger);
        return this;
    }

    remove(logger: ILoggerOutput): Logger {
        const idx = this.loggers.indexOf(logger);
        if (idx !== -1) {
            this.loggers.splice(idx, 1);
        }
        return this;
    }

    clear() {
        this.loggers = [];
    }
}

export const logger = new Logger();
